<template>
    <div class="card card-landing-course">
        <a :href="hrefCourse(course)">
            <!--<div class="card-image-top__sport-badge text-uppercase" v-text="getSportName(course)">
            </div>-->
            <div class="card-image-top">
                <img src="/images/16_9.png" style="width:100%">
                <div class="card-image-top__image-container">
                    <img v-if="course.course_thumb_image"
                         :src="course.course_thumb_image_full"
                         :alt="course.name" class="card-image-top__image-container__image">
                    <img v-else
                         :src="course.course_image"
                         :alt="course.name" class="card-image-top__image-container__image">
                </div>
                <span class="badge badge-pill badge-light card-age-range"
                      v-text="ageRange"></span>
            </div>
            <div class="card-body">
                <div
                    class="d-flex align-items-center font-13 line-height-18 mb-1"
                    style="height: 35px;"
                >
                    <span class="card-company-name"
                          v-text="course.company.name"></span>
                </div>
                <div class="card-body__course-title-container card-body__section m-0">
                    <p class="card-body__course-title-container__course-title mb-2">
                        Corso di <span v-text="course.sport.name" class="text-primary"></span>
                        per <span v-text="course.recipient"></span></p>
                </div>
                <div class="d-flex align-items-center font-13 line-height-18 mb-2 border-bottom">
                    <i class="fas fa-map-marker-alt text-gray-500 mr-1 font-10"></i>
                    <span class="text-truncate text-gray-500 font-12" v-text="courseAddress(course)"></span>
                </div>
                <div class="card-body__course-rating-distance-container card-body__section m-b-10 m-t-0">
                    <div class="card-body__course-rating-distance-container__rating-container">
                        <star-rating
                            v-if="course.reviews_avg_score > 0"
                            v-model="course.reviews_avg_score"
                            :star-size="9"
                            :read-only="true"
                            :show-rating="false"
                            :increment="0.01"
                            :fixed-points="2"
                            inactive-color="#ffffff"
                            border-color="#17BEBB"
                            active-color="#17BEBB"
                            :border-width="4"
                            :star-points="[23,2, 16,18, 0,19, 14,31, 8,48, 23,39, 39,48, 32,31, 46,19, 30,18]"
                        ></star-rating>
                    </div>
                    <span v-if="course.reviews_avg_score > 0"
                          class="card-body__course-rating-distance-container__divider"> • </span>
                    <div class="card-body__course-rating-distance-container__distance-container">
                        <p v-if="course.distance_from_my_position"
                           class="card-body__course-rating-distance-container__distance-container__distance">
                            {{getCourseDistance(course) }} da te
                        </p>
                    </div>
                </div>
                <div class="card-body__lessons card-body__section d-flex justify-content-around">
                    <span v-for="day in days" class="card-body__lessons__day"
                            :class="{'card-body__lessons__day--has-lesson': day.lesson}">
                        {{day.name}}
                    </span>
                </div>
                <div class="text-center mt-3 mb-3">
                    <a :href="hrefCourse(course)" class="btn btn-primary w-100">Scopri</a>
                </div>
            </div>
        </a>
    </div>
</template>
<script>
    import StarRating from 'vue-star-rating';

    export default {
        name: 'CourseCardItem',
        props: {
            courseprop: {
                type: Object,
                required: true
            },
            isDetail: {
                type: Boolean,
                required: false
            },
            insideMap: {
                type: Boolean,
                required: false
            }
        },
        components: {StarRating},
        data() {
            return {
                days: [
                    {name: 'L', long: 'Lunedì'},
                    {name: 'M', long: 'Martedì'},
                    {name: 'M', long: 'Mercoledì'},
                    {name: 'G', long: 'Giovedì'},
                    {name: 'V', long: 'Venerdì'},
                    {name: 'S', long: 'Sabato'},
                    {name: 'D', long: 'Domenica'}
                ],
                tempTags: [
                    {icon: 'fa-map-marker-alt', text: 'A 10 minuti da te', color: 'orangogo'},
                    {icon: 'fa-tag', text: '-30% sconto', color: 'primary'}
                ],
                reviews_avg_score: 0,
                course: null
            }
        },
        mounted() {


        },
        created() {
            this.course = this.courseprop;
            this.reviews_avg_score = this.course.reviews_avg_score;
            if (!this.course.days) this.course.days = []
            for (const day of this.days) {
                const lesson = this.course.days.find(les => les.day.toLowerCase() === day.long.toLowerCase());
                if (lesson) {
                    day.lesson = true;
                }
            }
        },
        computed: {
          ageRange: function () {
              var self = this;
              return self.course.start_age + " - " + self.course.end_age + " anni"
          }
        },
        methods: {
            loadFilteredCourses(courses) {
                this.course = courses
            },
            getSportName(course) {
                if (course.sport)
                    return course.sport.name;
                return '';
            },
            getCourseDistance(course) {
                if (course.distance_from_my_position < 1)
                    return (course.distance_from_my_position * 1000) + " m";
                return Math.round(course.distance_from_my_position) + " km";
            },
            hrefCourse(course) {
                return `/corsi/${course.slug}`;
            },
            courseSeoName(course) {
                if (course.sport)
                    return `Corso di ${course.sport.name} - ${course.start_age} / ${course.end_age} anni`;
                return `Corso - ${course.start_age} / ${course.end_age} anni`
            },
            courseAddress(course) {
                return course.municipality + ", " + course.route + " " + course.house_number;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/home/HomeCourseCard.vue